import type { Notification } from '@/entities/notification';

export function notificationLink(
  n: Pick<Notification, 'eventType' | 'ticketId' | 'payload' | 'requiresMyApproval'>,
  currentUserId?: string | null,
): string {
  if (n.eventType === 'system_status') return '/status';
  if (n.eventType.startsWith('approval_')) {
    if (n.requiresMyApproval) return `/approvals/${n.ticketId}`;
    const approverId = n.payload?.approverId;
    if (
      n.eventType === 'approval_created' &&
      currentUserId &&
      typeof approverId === 'string' &&
      approverId === currentUserId
    ) {
      return `/approvals/${n.ticketId}`;
    }
  }
  const chatId = n.payload?.chatId;
  if (typeof chatId === 'string' && chatId) {
    const messageId = n.payload?.messageId;
    return `/messenger/${chatId}${typeof messageId === 'string' ? `?message=${messageId}` : ''}`;
  }
  const taskId = n.payload?.taskId;
  if (typeof taskId === 'string' && taskId) {
    const commentId = n.payload?.commentId;
    return `/sprints?task=${taskId}${typeof commentId === 'string' ? `&comment=${commentId}` : ''}`;
  }
  const sprintId = n.payload?.sprintId;
  const groupId = n.payload?.groupId;
  if (typeof sprintId === 'string' && sprintId) {
    return `/sprints?sprint=${sprintId}${typeof groupId === 'string' ? `&group=${groupId}` : ''}`;
  }
  return `/tickets/view/${n.ticketId}`;
}
